import { useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { portalApiClient } from "../apiClient";
import { apiUrls } from "src/consts/ApiUrls";

export default function useMyUser(enabled?: boolean) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryFn: async () => {
      const response = (await portalApiClient.get(apiUrls.me)).data;

      return response;
    },
    queryKey: [...queryKeys.myUser()],
    ...(enabled !== undefined ? { enabled } : {}),
  });

  return {
    ...query,
    invalidate: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.myUser() }),
  };
}
